module.exports = __webpack_public_path__ + "img/care_guide_3.626016b8.png";